module.exports = __webpack_public_path__ + "static/img/h5logo.0072a69.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/h5logo.png
// module id = qv1d
// module chunks = 1